export const PROGRAM_PERFIX_PATH = '/program/';

export const LOGIN_REQUEST = 'cap/LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'cap/LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'cap/LOGIN_FAILURE';
export const LOGOUT_REQUEST = 'cap/LOGOUT_REQUEST';
export const LOGOUT_SUCCESS = 'cap/LOGOUT_SUCCESS';
export const LOGOUT_FAILURE = 'cap/LOGOUT_FAILURE';

export const SIDEBAR_MENU_ITEM_POSITION = 'left';
export const SETTINGS_URL = '/settings';
export const NOTIFICATION_URL = '/notifications';
export const ORG_SETTINGS_URL = '/org/index';
export const MODULE_NAME_URL = '/settings';
export const HELP_URL =
  'https://support.capillarytech.com/en/support/solutions/97443';

export const GET_SIDEBAR_MENU_DATA_REQUEST =
  'cap/GET_SIDEBAR_MENU_DATA_REQUEST';
export const GET_SIDEBAR_MENU_DATA_SUCCESS =
  'cap/GET_SIDEBAR_MENU_DATA_SUCCESS';
export const GET_SIDEBAR_MENU_DATA_FAILURE =
  'cap/GET_SIDEBAR_MENU_DATA_FAILURE';
export const CLEAR_SIDEBAR_MENU_DATA = 'cap/CLEAR_SIDEBAR_MENU_DATA';

export const GET_TOPBAR_MENU_DATA_REQUEST = 'cap/GET_TOPBAR_MENU_DATA_REQUEST';
export const GET_TOPBAR_MENU_DATA_SUCCESS = 'cap/GET_TOPBAR_MENU_DATA_SUCCESS';
export const GET_TOPBAR_MENU_DATA_FAILURE = 'cap/GET_TOPBAR_MENU_DATA_FAILURE';
export const CLEAR_TOPBAR_MENU_DATA = 'cap/CLEAR_TOPBAR_MENU_DATA';

export const GET_USER_DATA_REQUEST = 'cap/GET_USER_DATA_REQUEST';
export const GET_USER_DATA_SUCCESS = 'cap/GET_USER_DATA_SUCCESS';
export const GET_USER_DATA_FAILURE = 'cap/GET_USER_DATA_FAILURE';

export const SWITCH_ORG_REQUEST = 'cap/SWITCH_ORG_REQUEST';
export const SWITCH_ORG_SUCCESS = 'cap/SWITCH_ORG_SUCCESS';
export const SWITCH_ORG_FAILURE = 'cap/SWITCH_ORG_FAILURE';

export const PRODUCTION = 'production';

export const LAST_SYNC_TIME_REQUEST = 'cap/LAST_SYNC_TIME_REQUEST';
export const LAST_SYNC_TIME_SUCCESS = 'cap/LAST_SYNC_TIME_SUCCESS';
export const LAST_SYNC_TIME_FAILURE = 'cap/LAST_SYNC_TIME_FAILURE';

export const GET_ALL_USERS_REQUEST = 'cap/GET_ALL_USERS_REQUEST';
export const GET_ALL_USERS_SUCCESS = 'cap/GET_ALL_USERS_SUCCESS';
export const GET_ALL_USERS_FAILURE = 'cap/GET_ALL_USERS_FAILURE';

export const STANDARD = 'STANDARD';
export const CLEAR_ORG_KPI_CONFIG_DATA = 'cap/CLEAR_ORG_KPI_CONFIG_DATA';

export const DESCEND = 'descend';
export const ASCEND = 'ascend';

export const UN_EARNED = 'UN_EARNED';
export const EARNED = 'EARNED';
export const IN_PROGRESS = 'IN_PROGRESS';

export const DATE_DISPLAY_FORMAT = 'D MMM YYYY, h:mm:ss A';
export const READABLE_DATE_FORMAT = 'DD MMM YYYY';

export const ABSOLUTE = 'ABSOLUTE';
export const RELATIVE = 'RELATIVE';
export const NEVER_EXPIRES = 'NEVER_EXPIRES';
export const FIXED_DATE = 'FIXED_DATE';
export const WITH_BADGE_META = 'WITH_BADGE_META';

export const INDIVIDUAL = 'INDIVIDUAL';
export const ACROSS = 'ACROSS';
export const DAYS = 'DAYS';
export const WEEKS = 'WEEKS';
export const MONTHS = 'MONTHS';
export const YEARS = 'YEARS';
export const NEVER = 'NEVER';

export const SUNDAY = 'SUNDAY';
export const MONDAY = 'MONDAY';
export const TUESDAY = 'TUESDAY';
export const WEDNESDAY = 'WEDNESDAY';
export const THURSDAY = 'THURSDAY';
export const FRIDAY = 'FRIDAY';
export const SATURDAY = 'SATURDAY';

export const MAX_IMG_SIZE_IN_MB = 2;

export const customFieldDataTypes = {
  STRING: 'STRING',
  DATE: 'DATE',
  INTEGER: 'INTEGER',
  BOOLEAN: 'BOOLEAN',
};

export const NO = 'No';
export const BADGES = 'BADGES';

export const GET_SUPPORTED_LOCALES_REQUEST =
  'cap/GET_SUPPORTED_LOCALES_REQUEST';
export const GET_SUPPORTED_LOCALES_SUCCESS =
  'cap/GET_SUPPORTED_LOCALES_SUCCESS';
export const GET_SUPPORTED_LOCALES_FAILURE =
  'cap/GET_SUPPORTED_LOCALES_FAILURE';

export const RBAC_CONFIGURATION_PARAMETERS = {
  ENABLE_INCENTIVES_BADGES_ACCESS_VERIFICATION: 'ENABLE_INCENTIVES_BADGES_ACCESS_VERIFICATION',
  INCENTIVES_UPDATE_BADGES: 'INCENTIVES_UPDATE_BADGES',
};
export const MAX_PAST_DATE = '1925-01-01'
